/**
 * This function uses two divs that exist in _Layout.cshtml with aria-live,
 * inserting the message to the corresponding div to be read out by screen readers.
 * @param message The message that will be read out for screen readers
 * @param assertive Optional parameter to determine if the message should be polite or assertive.
 */

export function updateLiveMessage() {
    const liveMessageDiv = document.getElementById('polite-live-message');
    const liveMessageSecondDiv = document.getElementById('politeSecond-live-message');
    const resultatMessage = document.getElementById('resultatTekst')?.innerHTML ?? '';
    if (liveMessageDiv?.innerHTML === resultatMessage) {
        if (liveMessageSecondDiv) {
            liveMessageSecondDiv.innerHTML = resultatMessage;
        }
    } else if (liveMessageDiv) {
        liveMessageDiv.innerHTML = resultatMessage;
    }
}
